import React from 'react';
import { Link } from 'react-router-dom'
import './Button.scss';

function Button({ classes, text, onClick, to, isLink = false, color, backgroundColor, isBackButton = false, isSecondary = false }) {
  const buttonStyle = {
    color: color,
    backgroundColor: backgroundColor,
  }
  if (isLink) {
    return <Link to={to} onClick={onClick}><button className={"noselect " + classes} style={buttonStyle}>{text}</button></Link>;
  } else if (isBackButton) {
    buttonStyle.padding = `0`;
    return <button className={`back-button ${classes} noselect`} style={buttonStyle} onClick={onClick}>
      <img className="left-chevron" alt={`button`} src="/assets/icons/chevron-left-icon-dark.png" />
    </button>;
  } else {
    return <button className={classes + ' ' + (isSecondary ? "button-secondary noselect " : "")} style={buttonStyle} onClick={onClick}>{text}</button>;
  }
}

export default Button;
